import React, { useEffect, useState } from "react";

const PowerBiPOC = () => {
    // Responsive iframe dimensions
    const getIframeDimensions = () => {
        const width = Math.min(window.innerWidth * 0.9, 1320);
        const height = Math.min(window.innerHeight * 0.5, 800);
        return { width, height };
    };

    const [dimensions, setDimensions] = useState(getIframeDimensions());

    useEffect(() => {
        const handleResize = () => {
            setDimensions(getIframeDimensions());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div style={{ textAlign: "center" }}>
            <iframe
                title="PublicWebsite"
                width={dimensions.width}
                height={dimensions.height}
                src={process.env.REACT_APP_TREASURER_EMBED_URL}
                frameBorder="0"
                allowFullScreen={true}
                style={{ maxWidth: "100%", border: "none" }}
            />
        </div>
    );
};

export default PowerBiPOC;
